"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FUEL_RESET_LOG_ACCOUNT = exports.NOT_CONFIRMED_ERROR_CODE = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.NOT_CONFIRMED_ERROR_CODE = -1001;
exports.FUEL_RESET_LOG_ACCOUNT = new web3_js_1.PublicKey('FuE1gqp2fzw2sDNLrbZqKsqpphJcoSW6HPaSJjGd4RZ4');
